import * as Endpoints from '../endpoints';
import { GenericNotOkResponse } from '../types';

export const login = Endpoints.invokeSecurityLogin;
export const logoff = Endpoints.invokeSecurityLogoff;
export const refresh = Endpoints.invokeSecurityRefresh;
export const changePassword = Endpoints.invokeSecurityChangePassword;
export const resetPassword = Endpoints.invokeSecurityResetPassword;
export const resetPasswordRequest = Endpoints.invokeSecurityResetPasswordRequest;
export const validateResetPasswordRequest = Endpoints.invokeSecurityResetPasswordRequestValidation;
export const getFeatureFlags = Endpoints.invokeFeatureFlag;
export const getUserRole = Endpoints.invokeUserRole;
export const getUserRoleOperation = Endpoints.invokeUserRoleOperation;
export const reportTableData = Endpoints.invokeTableReportList;
export const getDeviceChannelData = Endpoints.invokeDeviceChannelData;
export const getDeviceConnection = Endpoints.invokeDeviceConnection;
export const getDeviceDetails = Endpoints.invokeDeviceDetails;
export const getStarfishDeviceDetails = Endpoints.invokeStarfishDeviceDetails;
export const getStarfishChildDeviceDetails = Endpoints.invokeStarfishChildDeviceDetails;
export const getDevices = Endpoints.invokeDeviceDevices;
export const getDevicesCount = Endpoints.invokeSiteDevicesCount;
export const getDeviceMasterData = Endpoints.invokeDeviceMaster;
export const getDeviceBlueprintData = Endpoints.invokeDeviceBlueprint;
export const getTemperatureGraphData = Endpoints.invokeTemperatureGraphData;
export const getHumidityGraphData = Endpoints.invokeHumidityGraphData;
export const getLoadGraphData = Endpoints.invokeLoadGraphData;
export const getPDIGraphData = Endpoints.invokePDIGraphData;
export const getQMAXGraphData = Endpoints.invokeQmaxApiData;
export const getPPCGraphData = Endpoints.invokePPCApiData;
export const getSensorListData = Endpoints.invokeSensorListData;
export const getAlarmSuggAcceptReject = Endpoints.invokeAlarmSuggAcceptReject;
export const getDatetimeListData = Endpoints.invokeDatetimeListData;
export const getDataPhaseResolvedGraph = Endpoints.invokePhaseResolvedGraphData;
export const getSensorTrendData = Endpoints.invokeSensorTrendData;
export const createSWGatewayDevice = Endpoints.invokeSWGatewayDeviceRegistration;
export const createPXGatewayDevice = Endpoints.invokePXGatewayDeviceRegistration;
export const createMeshGatewayDevice = Endpoints.invokeMeshGatewayDeviceRegistration;
export const createStarfishGatewayDevice = Endpoints.invokeStarfishGatewayDeviceRegistration;
export const createStarfishChildDevice = Endpoints.invokeStarfishChildDeviceRegistration;
export const createSWChildDevice = Endpoints.invokeSWChildDeviceRegistration;
export const getSierraGatewayDeviceDetails = Endpoints.invokeSierraGatewayDeviceDetails;
export const getSierraChildDeviceDetails = Endpoints.invokeSierraChildDeviceDetails;
export const sierraAlarmAcknowledgement = Endpoints.invokeSierraAlarmAcknowledge;
export const updateGatewayDeviceDetails = Endpoints.invokeSierraGatewayDeviceUpdate;
export const updateChildDeviceDetails = Endpoints.invokeSierraChildDeviceUpdate;
export const ResetUserSuggestionForm = Endpoints.invokeResetUserSuggestion;
export const deleteChildDevice = Endpoints.invokeSierraChildDeviceDelete;
export const getMeshGatewayDeviceDetails = Endpoints.invokeMeshGatewayDeviceDetails;
export const getPartNumberDetails = Endpoints.invokeGetPartNumberDetails;
export const getEulaDetails = Endpoints.invokeGetEulaDetails;
export const getSiteSubscriptionDetails = Endpoints.invokeGetSiteSubscriptionDetails;
export const getOrganizationType = Endpoints.invokeGetOrganizationType;
export const getLocations = Endpoints.invokeSiteLocations;
export const getOrganizations = Endpoints.invokeOrganizationList;

export const getSiteBatteryStatus = Endpoints.invokeSiteBatteryStatus;
export const getSiteDetails = Endpoints.invokeSiteDetails;
export const getSites = Endpoints.invokeSiteSites;
export const getSiteStatus = Endpoints.invokeSiteStatus;
export const siteRegistration = Endpoints.invokeSiteRegistration;
export const getSiteProfile = Endpoints.invokeSiteProfile;
export const getRelativeConditionIndex = Endpoints.invokeRelativeIndexApiData;
export const deleteSite = Endpoints.invokeSiteDelete;
export const deleteDevice = Endpoints.invokeDeleteDevice;
export const updateSiteProfile = Endpoints.invokeUpdateSiteRegistration;

export const getTrendsDetails = Endpoints.invokeTrendsDetails;
export const getDeviceTrendsDetails = Endpoints.invokeDeviceTrendsDetails;
export const getTrendChannels = Endpoints.invokeTrendChannels;
export const getTrendsSiteExportData = Endpoints.invokeTrendSiteExport;
export const getTrendsDeviceExportData = Endpoints.invokeTrendDeviceExport;
export const getUserSettings = Endpoints.invokeUserSettings;
export const setUserSettings = Endpoints.invokeUserSetSettings;

export const getSignalRConnection = Endpoints.invokeSignalRConnection;

export const registerUser = Endpoints.invokeUserRegistration;
export const requestUserRegistration = Endpoints.invokeUserRegistrationRequest;
export const validateUserRegistrationRequest = Endpoints.invokeUserRegistrationRequestValidation;
export const userRegistrationRole = Endpoints.invokeUserRegistrationRole;
export const userList = Endpoints.invokeUserList;
export const userDelete = Endpoints.invokeUserDelete;
export const updateUserRole = Endpoints.invokeUpdateRole;

export const getAlarmTimeline = Endpoints.invokeAlarmTimeline;
export const getAlarmDetails = Endpoints.invokeAlarmDetails;
export const getAlarmStatus = Endpoints.invokeAlarmStatus;
export const getAlarmCount = Endpoints.invokeAlarmCount;
export const getAlarmTimelineExport = Endpoints.invokeAlarmTimelineExport;
export const alarmAcknowledgement = Endpoints.invokeAlarmAcknowledge;
export const mappingSiteIdActivationId = Endpoints.invokeMappingSiteIdActivationId;
export const createEntitlement = Endpoints.invokeCreateEntitlement;
export const getSubscriptionLink = Endpoints.invokeGetSubscriptionLink;
export const alarmChannelDetail = Endpoints.invokeAlarmChannelDetails;
export const starfishAlarmAcknowledgement = Endpoints.invokeStarfishAlarmAcknowledge;
export const updateStarfishGatewayDevice = Endpoints.invokeStarfishGatewayDeviceUpdate;
export const deleteStarfishGateway = Endpoints.invokeDeleteStarfishGateway;
export const updateStarfishChildDevice = Endpoints.invokeStarfishChildDeviceUpdate;
export const saveAlarmFilters = Endpoints.invokeManageAlarmFilterSave;
export const getAlarmFilters = Endpoints.invokeManageAlarmFilterDetails;
export const updateAlarmFilters = Endpoints.invokeManageAlarmFilterUpdate;
export const deviceChannelCount = Endpoints.invokeManageAlarmDeviceChannelCount;
export const saveAlarmConfig = Endpoints.invokeManageAlarmsConfigSave;
export const updateAlarmConfig = Endpoints.invokeManageAlarmsConfigUpdate;
export const getAlarmConfig = Endpoints.invokeManageAlarmsConfigDetails;
export const getSiteGatewayList = Endpoints.invokeManageAlarmsGatewayList;
export const starfishUpgrade = Endpoints.invokeStarfishUpgrade;
export const deviceProfileChannels = Endpoints.invokeManageProfileChannelsData;
export const saveDeviceProfile = Endpoints.invokeManageProfileSave;
export const childProfileDetails = Endpoints.invokeChildProfileDetails;
export const deleteStarfishChildDevice = Endpoints.invokeDeleteStarfishChildDevice;
export const getDaylightSavingExcludedStates = Endpoints.invokeGetExcludedStates;
export const extractResponseNotOkCode = (response: GenericNotOkResponse): number => {
    if ('errorCode' in response) {
        return response.errorCode;
    }
    return response.statusCode;
};

export const extractResponseNotOkMessage = (response: GenericNotOkResponse): string => {
    if ('errorCode' in response) {
        return response.errorDescription;
    }
    return response.message;
};
export const extractErrorCodeWithMessage = (response: GenericNotOkResponse): string =>
    `${extractResponseNotOkCode(response)} ${'/'} ${extractResponseNotOkMessage(response)}`;
